import type { QueriesPaginationData } from '@empathybroker/tsclient-stats/dist/models/queries-pagination/queries-pagination-data'
import type { QueryData } from '@empathybroker/tsclient-stats/dist/models/queries/query-data'

import type { AnalyticsState, MutationClass } from '../../../models'

import Vue from 'vue'

export class SetSearchDataMutation implements MutationClass {
  static execute(
    this: void,
    state: AnalyticsState,
    payload: { queries: QueryData[]; totals: QueriesPaginationData; query: string },
  ): void {
    const searchData = {
      queries: payload.queries,
      totals: payload.totals,
    }
    if (!state.data.search[payload.query]) {
      Vue.set(state.data.search, payload.query, { ...searchData })
    } else {
      state.data.search[payload.query] = { ...searchData }
    }
  }
}
